import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { Wrapper } from "./component";
import UploadImage from "../UploadImage/UploadImage";
import { uploadKycDocument, uploadKycSelfie } from "../../redux/actions/media";
import { ArrowLeftOutlined } from "@ant-design/icons";
import {  Input, Modal, Select } from "antd";
import {
	btnStyle,
	ButtonLightPink,
	inputStyle,
	LandingTitle,
} from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { useMutation } from "react-query";
import { addUserKyc } from "../../redux/actions/wallet";
import errorHandler from "../../redux/actions/errorHandler";
import { viewUserProfile } from "../../redux/actions/authentication";
import { Loading } from "../Loading/Loading";

const KycSetup = ({ isKyc, setIsKyc }) => {
	const { Option } = Select;

	const [selfieImage, setSelfieimage] = useState([]);
	const [docImage, setDocimage] = useState([]);
	const [showDocCapture, setshowDocCapture] = useState(true);
	const [kyc, setKyc] = useState({
		document_type: "",
		document_number: "",
		document_media_url: "",
		face_photo_media_url: "",
	});

	const { mutateAsync: handleUpdateKyc, isLoading } = useMutation(addUserKyc);

	const handleKyc = async () => {
		if (isEmpty(selfieImage)) {
			Toast.fire({
				icon: "error",
				title: `Kindly capture a selfie photo to continue...`,
			});
			return;
		}
		if (isEmpty(docImage)) {
			Toast.fire({
				icon: "error",
				title: `Kindly capture document to be submit..`,
			});
			return;
		}
		if (isEmpty(kyc.document_type)) {
			Toast.fire({
				icon: "error",
				title: `Kindly select document type...`,
			});
			return;
		}
		if (isEmpty(kyc.document_number) || kyc.document_number.length < 5) {
			Toast.fire({
				icon: "error",
				title: `Invalid Document number`,
			});
			return;
		}

		const data = {
			document_type: kyc.document_type,
			document_number: kyc.document_number?.trim(),
			document_media_url: docImage[0],
			face_photo_media_url: selfieImage[0],
		};
		// console.log(data);
		try {
			const res = await handleUpdateKyc(data);
			console.log(res);
			const { hasError, errors } = res.data;
			if (hasError) {
				return errorHandler(errors);
			}
			Toast.fire({
				icon: "success",
				title: `${res.data.message}\n ${res.data.data}`,
			});
			viewUserProfile();
			setKyc({
				document_type: "",
				document_number: "",
				document_media_url: "",
				face_photo_media_url: "",
			});
		} catch (err) {
			console.log("the set kyc error", err);
		}
	};
	return (
		<Wrapper>
			<Modal
				footer=""
				visible={isKyc}
				centered
				onCancel={() => setIsKyc(false)}
				maskClosable={false}>
				<div
					tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
					onClick={() => setIsKyc(false)}>
					<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
				</div>
				<LandingTitle tw="text-center text-lg! mb-4">
					Add KYC Document
				</LandingTitle>
				<div tw="mt-4 mb-4!">
					<h4 tw="opacity-60 text-center mb-4">
						It is essential to provide a valid means of
						identification to help with verification process. Users
						are advised to provide a valid document
					</h4>
					<div tw="mt-4 flex flex-row justify-center items-center gap-2 flex-wrap h-full!">
						<div tw="">
							<UploadImage
								setImageUrlList={setSelfieimage}
								imageUrlList={selfieImage}
								uploadAPI={uploadKycSelfie}
								uploadText={"Upload Selfie Picture"}
								multiple={false}
								maxCount={1}
								useWebCamera
							/>
						</div>
						<div tw="h-full!">
							{!showDocCapture && (
								<div tw="flex justify-center items-center h-full">
									<UploadImage
										setImageUrlList={setDocimage}
										imageUrlList={docImage}
										uploadAPI={uploadKycDocument}
										uploadText={"Upload Selfie Picture"}
										multiple={false}
										maxCount={1}
										useWebCamera
										captureText={"Capture Document Image"}
									/>
								</div>
							)}
							{showDocCapture && (
								<div tw="w-full mt-4 h-full!">
									<div tw="h-full">
										<ButtonLightPink
											tw="w-full! h-12"
											onClick={() => {
												isEmpty(selfieImage)
													? Toast.fire({
															icon: "question",
															title: `Please capture selfie photo to continue with document image upload...`,
													  })
													: setshowDocCapture(false);
											}}>
											Capture Document
										</ButtonLightPink>
									</div>
								</div>
							)}
						</div>
					</div>
					<div tw="mt-6">
						<label
							htmlFor="name"
							className="label"
							tw="font-semibold text-base opacity-60">
							Document Type
						</label>
						<Select
							value={kyc.document_type}
							bordered={false}
							onChange={(value) => {
								setKyc({ ...kyc, document_type: value });
							}}
							placeholder={"Select preferred document type"}
							css={inputStyle}>
							<Option value="" tw="text-sm">
								Select preferred document type
							</Option>
							<Option value="national_id">
								National Identification Card{" "}
							</Option>
							<Option value="voters_card">
								Permanent Voters Card (PVC)
							</Option>
							<Option value="drivers_license">
								Driver's License
							</Option>
							<Option value="passport">
								International Passport
							</Option>
						</Select>
					</div>
					<div tw="mt-2">
						<label
							htmlFor="name"
							className="label"
							tw="font-semibold text-base opacity-60">
							Document Number
						</label>
						<Input
							placeholder="AB12345678"
							type="text"
							css={inputStyle}
							value={kyc.document_number}
							onChange={(e) => {
								console.log(e.target.value);

								setKyc({
									...kyc,
									document_number: e.target.value,
								});
							}}
						/>
					</div>

					<div tw="flex justify-center items-center w-full mt-4">
						<button
							css={btnStyle}
							onClick={() => {
								handleKyc();
							}}>
							{isLoading ? <Loading /> : "Submit"}
						</button>
					</div>
				</div>
			</Modal>
		</Wrapper>
	);
};

export default KycSetup;
